/**
 * LanguageSwitcher — toggle button between Japanese and English.
 *
 * Current language is persisted to localStorage automatically by i18next.
 */

import React from "react";
import { useTranslation } from "react-i18next";

const LANGUAGES = ["ja", "en"] as const;

export const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const current = i18n.language;

  return (
    <div className="lang-switcher" aria-label="Language switcher">
      {LANGUAGES.map((lang) => (
        <button
          key={lang}
          className={[
            "lang-switcher__btn",
            current === lang ? "lang-switcher__btn--active" : "",
          ]
            .filter(Boolean)
            .join(" ")}
          onClick={() => i18n.changeLanguage(lang)}
          aria-pressed={current === lang}
          aria-label={lang === "ja" ? "日本語" : "English"}
        >
          {lang.toUpperCase()}
        </button>
      ))}
    </div>
  );
};
